import { reusableStyles } from 'ui-blocks/ReusableStyles';

export const landingPageStyles = {
	mainContainer: {
		display: 'flex',
		position: 'relative',
		flexDirection: 'column',
		gap: { xs: '24px', smTab: '36px', lg: '56px', xl: '64px', xxl: '72px' },
		backgroundColor: 'colors.dark6',
	},
	navBar: { position: 'sticky', top: 0, zIndex: 2 },
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: { xs: '64px', smTab: '88px', xl: '120px' },
	},
	sectionContainer: {
		...reusableStyles.flexCol,
		gap: { xs: '64px', smTab: '88px', xl: '120px' },
		maxWidth: {
			smTab: '688px',
			tabletMid: '944px',
			lg: '1136px',
			xl: '1232px',
			xxl: '1512px',
		},
		marginX: { xs: '24px', smTab: 'auto' },
	},
	dividerStyle: {
		backgroundColor: 'colors.light5',
		width: '100%',
		borderRadius: '4px',
	},
	sectionDescriptionContainer: {
		display: 'flex',
		flexDirection: 'column',
		// gap: { xs: '8px', smTab: '16px', lg: '20px' },
		// TO DO
		gap: '8px', // default: ≤768px

		'@media (min-width: 769px)': {
			gap: '16px', // 769px to 1280px
		},
		'@media (min-width: 1281px)': {
			gap: '20px', // 1281px and above
		},
	},
};
